import COS from "cos-js-sdk-v5";
import {getCosTempToken} from "@/api";

// 创建cos对象，携带密钥上传文件至对象存储
let cos = new COS({
  getAuthorization: function (options, callback) {
    getCosTempToken("pos").then((res) => {
      console.log("获取costoken响应拦截", res.data);
      if (res.data.retcode == 0) {
        let data = res.data.data;
        callback({
          TmpSecretId: data.tmpSecretId,
          TmpSecretKey: data.tmpSecretKey,
          SecurityToken: data.sessionToken,
          ExpiredTime: data.expiredTime,
          PathPre: data.pathPre,
        });
        console.log("请求token时的文件地址", data.pathPre);
        sessionStorage.setItem("cosPath", data.pathPre);
        console.log(
          "从session中取出来的文件目录为",
          sessionStorage.getItem("cosPath")
        );
      }
    });
  },
});

// 处理base64格式的文件体，便于上传文件(不使用此函数转译base64就会将base64字符串保存为文件，不能获得真实图片)
let dataURLtoBlob = function (dataurl) {
  // console.log(dataurl);
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mime});
};

// 生成唯一的图片名
export function createUploadImgName(posId) {
  let partnerId = sessionStorage.getItem("partnerid");
  let DateNow = new Date().getTime();
  return partnerId + "_" + posId + "_" + DateNow + "." + "png";
}

// 保存图片url
export function getCOSUrl(name) {
  let cosPath = sessionStorage.getItem("cosPath");
  console.log("命名时的文件名", cosPath);
  let bashUrl = `https://washshare-1256601262.cos.ap-guangzhou.myqcloud.com/${cosPath}/`;
  return bashUrl + name;
}

// 上传的文件名和文件对象
export function uploadImg(fileObj, imgName, callbackFunc) {
  let file = dataURLtoBlob(fileObj);
  console.log("uploadImg()中的图片地址", imgName);
  console.log("存图片前的图片目录", sessionStorage.getItem("cosPath"));
  cos.putObject(
    {
      Bucket: "washshare-1256601262",
      Region: "ap-guangzhou",
      Key: sessionStorage.getItem("cosPath") + "/" + imgName,
      Body: file,
      onProgress: function (pd) {
        console.log(JSON.stringify(pd));
      },
    },
    function (err, data) {
      console.log(err || data);
      if (data.statusCode == 200) {
        let imgUrl = "https://" + data.Location;
        console.log('图片url为', imgUrl);
        callbackFunc(imgUrl);
      }
    }
  );
}

// 删除指定的对象
export function deletImgObject(img){
  let prefix = "https://washshare-1256601262.cos.ap-guangzhou.myqcloud.com";
  img = img.replace(prefix, "");
  console.log('输出的字符串是',img);
  cos.deleteObject({
    Bucket: 'washshare-1256601262', /* 填入您自己的存储桶，必须字段 */
    Region: 'ap-guangzhou',  /* 存储桶所在地域，例如ap-beijing，必须字段 */
    Key: img,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
  }, function(err, data) {
    console.log(err || data);
  });
}





// WEBPACK FOOTER //
// ./src/util/uploadImage.js